// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-toolbar {
  --background: linear-gradient(180deg, #0047af 0%, #0361cf 100%);
}
ion-header ion-toolbar ion-title {
  padding-left: 0;
}

:host .number-radius-icon {
  border: solid 2px #0ab2e6;
  color: #0ab2e6;
  border-radius: 100%;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  padding: 2px 7.77px;
}
:host ion-badge {
  padding: 10px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 13px;
  line-height: 15.25px;
}
:host .head {
  height: 59px;
}
:host .ion-align-items-flex-start {
  align-items: flex-start !important;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  color: black;
  font-size: 24px;
  cursor: pointer;
}

ion-card {
  box-shadow: none;
  text-align: left;
}
ion-card ion-item {
  height: 20px;
  align-items: flex-start;
}
ion-card ion-icon {
  color: #0ab2e6;
  height: 18px;
  width: 18px;
  margin: 0;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/shared/get-tax-info/get-tax-info.component.scss"],"names":[],"mappings":"AACE;EACE,+DAAA;AAAJ;AAEI;EACE,eAAA;AAAN;;AAME;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAJJ;AAOE;EACE,YAAA;AALJ;AAQE;EACE,kCAAA;AANJ;;AASA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AANF;;AAUA;EACE,gBAAA;EACA,gBAAA;AAPF;AAQE;EACE,YAAA;EACA,uBAAA;AANJ;AAQE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AANJ;AACA,4lEAA4lE","sourcesContent":["ion-header {\n  ion-toolbar {\n    --background: linear-gradient(180deg, #0047af 0%, #0361cf 100%);\n\n    ion-title {\n      padding-left: 0;\n    }\n  }\n}\n\n:host {\n  .number-radius-icon {\n    border: solid 2px #0ab2e6;\n    color: #0ab2e6;\n    border-radius: 100%;\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 18px;\n    padding: 2px 7.77px;\n  }\n\n  ion-badge {\n    padding: 10px;\n    border-radius: 30px;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 15.25px;\n  }\n\n  .head {\n    height: 59px;\n  }\n\n  .ion-align-items-flex-start {\n    align-items: flex-start !important;\n  }\n}\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10;\n  color: black;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n\nion-card {\n  box-shadow: none;\n  text-align: left;\n  ion-item {\n    height: 20px;\n    align-items: flex-start;\n  }\n  ion-icon {\n    color: #0ab2e6;\n    height: 18px;\n    width: 18px;\n    margin: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
